//GET_GEOFENCE_LIST
export const GET_ADMIN_GEOFENCE_LIST_REQUEST =
  "GET_ADMIN_GEOFENCE_LIST_REQUEST";
export const GET_ADMIN_GEOFENCE_LIST_SUCCESS =
  "GET_ADMIN_GEOFENCE_LIST_SUCCESS";
export const GET_ADMIN_GEOFENCE_LIST_FAIL = "GET_ADMIN_GEOFENCE_LIST_FAIL";

//CREATE_AIRTICKET
export const CREATE_ADMIN_GEOFENCE_REQUEST = "CREATE_ADMIN_GEOFENCE_REQUEST";
export const CREATE_ADMIN_GEOFENCE_SUCCESS = "CREATE_ADMIN_GEOFENCE_SUCCESS";
export const CREATE_ADMIN_GEOFENCE_FAIL = "CREATE_ADMIN_GEOFENCE_FAIL";

//DELETE_AIRTICKET
export const DELETE_ADMIN_GEOFENCE_REQUEST = "DELETE_ADMIN_GEOFENCE_REQUEST";
export const DELETE_ADMIN_GEOFENCE_SUCCESS = "DELETE_ADMIN_GEOFENCE_SUCCESS";
export const DELETE_ADMIN_GEOFENCE_FAIL = "DELETE_ADMIN_GEOFENCE_FAIL";

//ADD_EMPLOYEES
export const ADD_EMPLOYEE_REQUEST = "ADD_EMPLOYEE_REQUEST";
export const ADD_EMPLOYEE_SUCCESS = "ADD_EMPLOYEE_SUCCESS";
export const ADD_EMPLOYEE_FAIL = "ADD_EMPLOYEE_FAIL";
